/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_NoneInputs */



/**
* | output |
* | --- |
* | "As an NC or Prince, members must be able to reach you: add a contact email or a phone number, or link a Discord login in the Account tab." |
*
* @param {Profile_Contact_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_none = /** @type {((inputs?: Profile_Contact_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En tant que NC ou Prince, les membres doivent pouvoir vous joindre : ajoutez un e-mail de contact ou un téléphone, ou liez un compte Discord dans l'onglet Compte.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Como NC o Príncipe, los miembros deben poder contactarte: añade un correo de contacto o un teléfono, o vincula una cuenta de Discord en la pestaña Cuenta.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como NC ou Príncipe, os membros precisam poder contatá-lo: adicione um e-mail de contato ou um telefone, ou vincule uma conta Discord na aba Conta.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come NC o Principe, i membri devono poterti contattare: aggiungi un'email di contatto o un telefono, oppure collega un account Discord nella scheda Account.")
	return /** @type {LocalizedString} */ ("As an NC or Prince, members must be able to reach you: add a contact email or a phone number, or link a Discord login in the Account tab.")
});